import { useMutation } from "@tanstack/react-query"
import { toast } from "sonner"

import { supabase } from "@/lib/supabase"

export const useEmailIndividualApplication = () => {
  return useMutation({
    mutationFn: async ({
      applicationId,
      redirectUrl,
    }: {
      applicationId: string
      redirectUrl: string
    }) => {
      try {
        const { data, error } = await supabase.functions.invoke("email-inprogress-applicants", {
          body: {
            applicationId,
            redirectUrl,
          },
        })

        if (error) {
          throw new Error(error.message)
        }

        return data
      } catch (error) {
        console.error(`Error emailing application ${applicationId}:`, error)
        throw error
      }
    },
    onSuccess: (data) => {
      toast.success("Success", {
        description: data.message || "Email sent successfully to applicant.",
      })
    },
    onError: (error) => {
      toast.error("Error", {
        description: `Failed to send email: ${error.message}`,
      })
    },
  })
}
